// components/RefundDetails.js
import React from 'react';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { useParams, useNavigate } from 'react-router-dom';
import { getRefundRequestById, deleteRefundRequest } from '../../services/refundService';
import { formatDistanceToNow } from 'date-fns';
const RefundDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const { data, error, isLoading } = useQuery(['refundRequest', id], () => getRefundRequestById(id));
  const mutation = useMutation(() => deleteRefundRequest(id), {
    onSuccess: () => {
      queryClient.invalidateQueries(['refundRequests']);
      navigate('/');
    },
  });
console.log(data)
  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error: {error.message}</div>;

  return (
    <div>
      <h1>Refund Request Details</h1>
      <p>User: {data.user ? data.user.name : 'Unknown'}</p>
      <p>Status: {data.status}</p>
      <p>Requested: {formatDistanceToNow(new Date(data.requestDate))} ago</p>
      <button onClick={() => mutation.mutate()}>Delete Refund Request</button>
    </div>
  );
};

export default RefundDetails;
